import React from "react";
import { Box, Container, Typography, Card, CardContent, Button, Grid } from "@mui/material";
import { MessageType } from "../models/message";
import { User } from "firebase/auth";
import { staffService } from "../services/firebase/staffService";



const handleAcceptInvitation = async (
    message: MessageType,
    restaurantId: string,
    messages: MessageType[],
    user: User,
    setError: React.Dispatch<React.SetStateAction<string>>,
    setMessages: React.Dispatch<React.SetStateAction<MessageType[]>>
) => {
    try {
        if (!user || !user.uid) {
            setError("You must be signed in to accept invitations.");
            return;
        }
        await staffService.acceptStaffInvitation(user.uid, restaurantId, message);
        setMessages(messages.filter((msg) => msg.id !== message.id)); // Remove the message from state
    } catch (err) {
        setError("Failed to accept invitation. Please try again later.");
    }
};

export interface StaffInvitationMessageProps {
    message: MessageType,
    messages: MessageType[],
    user: User | null,
    setError: React.Dispatch<React.SetStateAction<string>>,
    setMessages: React.Dispatch<React.SetStateAction<MessageType[]>>
}

export const StaffInvitationMessage: React.FC<StaffInvitationMessageProps> = ({
    message,
    messages,
    user,
    setError,
    setMessages
}) => {
    return (
        <Card>
            <CardContent>
                <Typography variant="h6">{message.title}</Typography>
                <Typography variant="body2" color="textSecondary" gutterBottom>
                    {message.description}
                </Typography>

                {message.type === "staff_invitation" && message.cta === "accept" && message.cta_target && (
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={() => handleAcceptInvitation(message, message.cta_target!, messages, user!, setError, setMessages)}
                    >
                        Accept Invitation
                    </Button>
                )}

                {message.cta === "open" && message.cta_target && (
                    <Button 
                        variant="outlined" 
                        sx={{ margin: "0 8px", background: "#162C1F", border: "1px solid #162C1F", borderRadius: "24px"}}
                        onClick={() => window.open(message.cta_target, "_blank")}>
                        Open
                    </Button>
                )}
            </CardContent>
        </Card>
    )
}